import { render, staticRenderFns } from "./SimpleCrudV2.vue?vue&type=template&id=b6005ed4"
import script from "./SimpleCrudV2.vue?vue&type=script&lang=js"
export * from "./SimpleCrudV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports